module.exports = __webpack_public_path__ + "static/media/chess-rook-alt.4ee580c7.svg";